export const authUrl = "/api/v1/users";
export const orderUrl = "/api/v1/orders";
export const captchaUrl = "/api/v1/users/verify";
export const paymentUrl = "/api/v1/payments";
export const indexCheckUrl = "/api/v1/index-check";
export const devApiUrl = "/api/v1/dev";
export const couponUrl = "/api/v1/coupons";
